(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-info-drawer"] && !Shopify.designMode) return;
  try {
    class DeliveryInfoDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.triggerButtons = document.querySelectorAll('delivery-drawer-button');
    this.closeButton = this.querySelector('.delivery-info-drawer__close');
    this.initEventListeners();
  }

  initEventListeners() {
    this.triggerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleDrawer();
      });
    });

    // Close drawer when clicking on backdrop
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.toggleDrawer();
      }
    });

    // Close drawer when clicking on close button
    this.closeButton.addEventListener('click', () => {
      this.toggleDrawer();
    });

    // close on ESC key press if drawer is open
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('active')) {
        this.toggleDrawer();
      }
    });
  }
  toggleDrawer() {
    this.classList.toggle('active');
  }
}

customElements.define('delivery-info-drawer', DeliveryInfoDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-link-with-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-links-with-tabs')) {
    customElements.define('image-links-with-tabs', class ImageLinksWithTabs extends HTMLElement {
      constructor() {
        super();

      }

        connectedCallback() {
          const tabList = this.querySelector('.image-links-with-tabs__tab-list');
          if (!tabList || tabList.children.length === 1) return;

          const tabs = this.querySelectorAll('images-tab');
          const groups = this.querySelectorAll('images-group');

          tabList.addEventListener('click', (event) => {
            const clickedTab = event.target.closest('images-tab');
            if (!clickedTab) return;

            const targetGroupTitle = clickedTab.dataset.groupTitle;
            const targetGroup = this.querySelector(`images-group[data-group-title="${targetGroupTitle}"]`);
            if (!targetGroup) return;

            // Deactivate all tabs and hide all groups
            tabs.forEach(tab => tab.removeAttribute('active'));
            groups.forEach(group => group.setAttribute('hidden', ''));

            // Activate the clicked tab and show the corresponding group
            clickedTab.setAttribute('active', '');
            targetGroup.removeAttribute('hidden');

          });
        }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-locator-drawer"] && !Shopify.designMode) return;
  try {
    class StoreLocatorDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.triggerButtons = document.querySelectorAll('store-locator-button');
    this.closeButton = this.querySelector('.store-locator-drawer__close');
    this.initEventListeners();
  }

  initEventListeners() {
    this.triggerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleDrawer();
      });
    });

    // Close drawer when clicking on backdrop
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.toggleDrawer();
      }
    });

    // Close drawer when clicking on close button
    this.closeButton.addEventListener('click', () => {
      this.toggleDrawer();
    });

    // close on ESC key press if drawer is open
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('active')) {
        this.toggleDrawer();
      }
    });
  }
  toggleDrawer() {
    this.classList.toggle('active');
  }
}

customElements.define('store-locator-drawer', StoreLocatorDrawer);
  } catch(e) { console.error(e); }
})();

})();
